import { Pipe, PipeTransform } from '@angular/core';
import { Application } from '../../../enums/application.enums';
import { Options } from '@cotufa82/ng-ivs';
import { getVideoSourceMimeType } from 'src/app/utils/common.utils';

const IVS_PLAYBACK_HOST = 'live-video.net';
const HTML5_TECH = 'html5';

@Pipe({
  name: 'videoOption'
})
export class VideoOption implements PipeTransform {
  transform(
    mediaUrl,
    {
      autoPlay,
      muted,
      type,
      videoMode,
      setAspectRatio,
      controlBar,
      isLivestream
    }: {
      autoPlay: boolean;
      muted: boolean;
      type?: string;
      videoMode?: string;
      setAspectRatio?: boolean;
      controlBar?: any;
      isLivestream?: boolean;
    }
  ) {
    let option: Options;
    if (mediaUrl) {
      const videoSrc = Array.isArray(mediaUrl)
        ? mediaUrl[Application.ZERO]
        : mediaUrl;
      const newVideoSrc =
        typeof videoSrc === 'string'
          ? videoSrc.split('+').join('%2B')
          : videoSrc;
      const sourceType =
        typeof newVideoSrc === 'string'
          ? getVideoSourceMimeType(newVideoSrc, type)
          : type;
      const isIvsPlayback =
        Boolean(isLivestream) ||
        (typeof newVideoSrc === 'string' &&
          newVideoSrc.includes(IVS_PLAYBACK_HOST));
      const sources: Array<{
        src: string;
        type?: string;
      }> = [
        {
          src: newVideoSrc,
          ...(sourceType ? { type: sourceType } : {})
        }
      ];
      option = Object.assign({
        sources,
        fluid: !isLivestream,
        autoplay: Boolean(autoPlay),
        controls: true,
        muted: muted,
        loop: Boolean(autoPlay),
        bigPlayButton: true,
        preload: 'auto',
        ...(!isIvsPlayback
          ? {
              techOrder: [HTML5_TECH],
              html5: {
                vhs: {
                  overrideNative: false
                }
              }
            }
          : {})
      });
      
      // If controlBar is provided, use it directly
      if (controlBar) {
        option['bigPlayButton'] = false;
        option['controlBar'] = controlBar;
      }
      
      if (videoMode) {
        if (videoMode === Application.PORTRAIT) {
          option['aspectRatio'] = '9:16';
        } else {
          option['aspectRatio'] = '16:9';
        }
      } else if (setAspectRatio) {
        option['aspectRatio'] = '16:9';
      }
    } else if (mediaUrl === '') {
      option = Object.assign({
        sources: [],
        fluid: !isLivestream,
        autoplay: Boolean(autoPlay),
        controls: true,
        muted: muted,
        loop: Boolean(autoPlay),
        bigPlayButton: true,
        preload: 'auto',
      });
      
      // If controlBar is provided, use it directly
      if (controlBar) {
        option['bigPlayButton'] = false;
        option['controlBar'] = controlBar;
      }
      
      option['aspectRatio'] = '16:9';
    }
    return option;
  }
}
